import transformImage, { type ImageOptions } from '../transform/transformImage';

export function resolvePostImage(
  publicId: string,
  options: ImageOptions = {},
  srcUrl?: string,
  fallbackPostImage?: string,
): string | null {
  return transformImage(publicId, options, srcUrl) ?? fallbackPostImage ?? null;
}
